import { Modal, Offcanvas } from 'react-bootstrap';
import MobileSliderPagesWrapper
    from '../../../mobileAppCore/components/MobileSliderPages/components/MobileSliderPagesWrapper';
import FlashScreen, { FlashScreenDesktop } from '../../../components/FlashScreen/FlashScreen';
import {
    AchievementPreviewCompletedDateStyled,
    AchievementPreviewFlashScreenStyled,
    AchievementPreviewProgressStyled,
    AchievementPreviewTimesStyled,
} from './styled/AchievementPreviewStyled';
import { PUBLIC_URL } from '../../../config';
import { ACHIEVEMENT_CATEGORIES, ACHIEVEMENT_STATUS } from '../achievementsConstants';
import moment from 'moment';
import React, { useMemo } from 'react';
import _ from 'lodash';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import { IUserAchievementSummary } from '../achievements.t';
import { useSelector } from 'react-redux';
import { getIsLocationPlatformDesktopSelector } from '../../Location/locationSelectors';
import classNames from 'classnames';

interface IAchievementModalProps {
    achievement: IUserAchievementSummary,
    showModal: boolean,
    progress: number,
    handleClose: () => void,
}

function AchievementModal(props: IAchievementModalProps) {
    const {
        achievement,
        showModal,
        progress,
        handleClose,
    } = props;
    const { getLangPath } = useLangContext();
    const isDesktop = useSelector(getIsLocationPlatformDesktopSelector);

    const category = useMemo(() => {
        return _.find(ACHIEVEMENT_CATEGORIES, { achievements: [achievement.achievement_name] })?.name;
    }, [achievement]);

    const title = useMemo(() => {
        if (progress) {
            return getLangPath(`achievements.progress.categories.${category}`, {
                amount: achievement.progress.toString(),
                target: achievement.target.toString(),
            });
        }
        return getLangPath(`achievements.glory_arena.${achievement.achievement_name}.title`);
    }, [achievement, category, getLangPath, progress]);

    const innerContent = useMemo(() => {
        return <AchievementPreviewFlashScreenStyled
            className={classNames('d-flex text-center align-items-center', {
                'flex-column': !isDesktop,
                'justify-content-center': isDesktop,
                'gap-5': isDesktop,
            })}>
            <img
                src={`${PUBLIC_URL}/assets/achievements/full/${achievement.status === ACHIEVEMENT_STATUS.COMPLETED ? achievement.achievement_name : `${achievement.achievement_name}_inactive`}_full.png`}
                alt={''}/>

            <div>
                <h5 className={'mt-4 mb-2'}>{title}</h5>

                {
                    achievement.times > 1 && <AchievementPreviewTimesStyled>
                        {getLangPath('achievements.glory_arena.times', { count: achievement.times.toString() })}
                    </AchievementPreviewTimesStyled>
                }

                {
                    achievement.status !== ACHIEVEMENT_STATUS.COMPLETED &&
                    <span className={'f14 fw400'}>
                        {getLangPath(`achievements.glory_arena.${achievement.achievement_name}.description`)}
                    </span>
                }

                {
                    !!progress &&
                    <div className={'mt-3 mx-4'} style={{ alignSelf: 'normal' }}>
                        <AchievementPreviewProgressStyled
                            percent={progress}/></div>
                }

                {
                    achievement.status === ACHIEVEMENT_STATUS.COMPLETED &&
                    <AchievementPreviewCompletedDateStyled>
                        {moment(achievement.completed_at).format(getLangPath('format.date'))}
                    </AchievementPreviewCompletedDateStyled>
                }
            </div>
        </AchievementPreviewFlashScreenStyled>;
    }, [achievement, getLangPath, progress, title, isDesktop]);

    if (isDesktop) {
        return <Modal show={showModal} centered onHide={handleClose} size={'lg'}>
            <FlashScreenDesktop handleClose={handleClose}>
                {innerContent}
            </FlashScreenDesktop>
        </Modal>;
    }

    return <Offcanvas show={showModal}
                      placement={'end'}
                      style={{
                          width: '100%',
                          zIndex: 1100,
                      }}
                      onHide={handleClose}>
        <MobileSliderPagesWrapper>
            <FlashScreen handleClose={handleClose}>
                {innerContent}
            </FlashScreen>
        </MobileSliderPagesWrapper>
    </Offcanvas>;
}

export default AchievementModal;
